import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const FILTERED_PAYMENT_METHODS = [
  'cash2',
  'bit_poalim',
  'transfer_poalim',
  'paybox_poalim'
];

export const FilterProvider = ({ children }) => {
  const [isFilterActive, setIsFilterActive] = useState(() => {
    try {
      const saved = localStorage.getItem('diam_filter_active');
      return saved ? JSON.parse(saved) : false;
    } catch {
      return false;
    }
  });

  const toggleFilter = () => {
    const newState = !isFilterActive;
    setIsFilterActive(newState);
    try {
      localStorage.setItem('diam_filter_active', JSON.stringify(newState));
    } catch (error) {
      console.warn('לא ניתן לשמור מצב סינון:', error);
    }
  };

  const shouldHideBooking = (booking) => {
    if (!isFilterActive) return false;
    return booking.paymentStatus &&
           booking.paymentStatus !== 'unpaid' &&
           FILTERED_PAYMENT_METHODS.includes(booking.paymentStatus);
  };

  const filterBookings = (bookings) => {
    if (!isFilterActive || !Array.isArray(bookings)) return bookings;
    return bookings.filter(booking => !shouldHideBooking(booking));
  };

  const shouldHidePaymentMethod = (paymentMethod) => {
    return isFilterActive && FILTERED_PAYMENT_METHODS.includes(paymentMethod);
  };

  const filterPaymentMethods = (paymentMethods) => {
    if (!isFilterActive || !Array.isArray(paymentMethods)) return paymentMethods;
    return paymentMethods.filter(method => {
      const value = typeof method === 'string' ? method : method.value;
      return !FILTERED_PAYMENT_METHODS.includes(value);
    });
  };

  const value = {
    isFilterActive,
    toggleFilter,
    shouldHideBooking,
    filterBookings,
    shouldHidePaymentMethod,
    filterPaymentMethods,
    FILTERED_PAYMENT_METHODS
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};

export default FilterContext;
